import SparkMD5 from 'spark-md5'
const appName = 'testdrive'
const environment = window.config ? window.config.environment : 'local'

let hash = (key) => {
  const concatenatedKey = `${appName}/${environment}/${key}`
  const hashedValue = SparkMD5.hash(concatenatedKey)
  return hashedValue
}
export default {
  session: {
    setItem(key, value) {
      sessionStorage.setItem(hash(key), value)
    },
    getItem(key) {
      return sessionStorage.getItem(hash(key))
    },
    clear() {
      sessionStorage.clear()
    }
  },
  local: {
    setItem(key, value) {
      localStorage.setItem(hash(key), value)
    },
    getItem(key) {
      return localStorage.getItem(hash(key))
    },
    clear() {
      localStorage.clear()
    }
  }
}
